import { action, observable } from 'mobx';

import type TIconIds from 'bz-icons/src/common/type/icon-ids';

class IconsLoadedStore {
  @observable loaded: Set<TIconIds> = new Set();

  @action.bound
  load(id: TIconIds) {
    this.loaded.add(id);
  }
}

export default IconsLoadedStore;
